import React from 'react';
import ReactDOM from 'react-dom';
import GlobalStyle from 'styles/GlobalStyle';
import App from './App';
import './i18n';
import { initialize, pageview } from 'react-ga';

initialize('G-WYTCD47WWK');

pageview(window.location.pathname + window.location.search);

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
